import Endpoint from '../Endpoint'

export default class User extends Endpoint {
  async signup(email, password, source) {
    return this.client.request({
      method: 'POST',
      endpoint: '/users',
      data: {
        email,
        password,
        source,
      },
    })
  }

  async activate(token) {
    return this.client.request({
      method: 'POST',
      endpoint: '/users/activate',
      data: {
        token,
        clientId: this.client.clientId
      },
    })
  }

  async requestPasswordReset(email) {
    return this.client.request({
      method: 'POST',
      endpoint: '/users/request_password_reset',
      data: {
        email,
      },
    })
  }

  async passwordReset(userId, token, password) {
    return this.client.request({
      method: 'POST',
      endpoint: `/users/${userId}/password_reset`,
      data: {
        token,
        password,
      },
    })
  }

  async getCurrent() {
    return this.client.request({
      method: 'GET',
      endpoint: '/users/current',
    })
  }
}



// WEBPACK FOOTER //
// ../source/api/endpoints/User.js